import { ILogger, LogMessage, VelocityEvent, LoggerConfig } from '@velociti/core'

export class VelocitiLogger implements ILogger {
  constructor(private config: LoggerConfig = new LoggerConfig()) {
    //
  }

  debug(...args: LogMessage[]): void {
    this.writeLog('debug', ...args)
  }
  info(...args: LogMessage[]): void {
    this.writeLog('info', ...args)
  }
  warn(...args: LogMessage[]): void {
    this.writeLog('warn', ...args)
  }
  error(...args: LogMessage[]): void {
    this.writeLog('error', ...args)
  }
  log(...args: LogMessage[]): void {
    this.writeLog('log', ...args)
  }
  event(...args: VelocityEvent[]): void {
    this.writeLog('event', ...args)
  }

  getConfig(): LoggerConfig {
    return this.config
  }
  setConfig(config: LoggerConfig): void {
    this.config = config
  }

  private writeLog(key: string, ...args: LogMessage[]): void {
    for (let i = 0; i < args.length; i++) {
      const arg = args[i]

      for (const ai in this.config.getAppenders()) {
        const appender = this.config.getAppenders()[ai]
        appender[key](arg)
      }
    }
  }

  //LogEntry | VelocityEvent | string | unknown
}
